import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import images from 'images/images.jfif';
import { getImg } from '../../utils';
import moment from 'moment';
import Pagination from '@material-ui/lab/Pagination';
import { BsCheck, BsX } from 'react-icons/bs';
import { GoSearch, GoSortDesc } from 'react-icons/go';
import {
  AiOutlineSortAscending,
  AiOutlineSortDescending,
} from 'react-icons/ai';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Menu,
  MenuItem,
  TextField,
} from '@material-ui/core';
import { BiDotsVerticalRounded } from 'react-icons/bi';
import { RxCross2 } from "react-icons/rx";
import DragAndDropInputDiv from 'components/DragandDrop';
import ImageCrop from 'components/ImageCrop';
import { uploadIdentityProofRequest } from 'features/Users/usersSlice';
import { useDispatch } from 'react-redux';

const useStyles = makeStyles({
  container: {
    margin: '1rem',
  },
  status: {
    height: '20px',
    width: '20px',
    margin: '0 auto',
    borderRadius: '50%',
  },
  activate: {
    background: 'green',
  },
  deactivate: {
    background: 'red',
  },
  red: {
    color: 'red',
  },
  green: {
    color: 'green',
  },
  imgWidth: {
    width: '50px',
  },
  uploadImgmodal: {
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100%',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'rgba(0, 0, 0, 0.5)',
    zIndex: '1000',

  },
  uploadImgmodalChildren: {
    width: 'max-content',
    height: 'max-content',
    maxWidth: '80%',
    maxHeight: '80vh',
    padding: '50px',
    borderRadius: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    background: 'white',
    position: 'relative',

  },
  uploadImgmodalCross: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: "#303a33",
    padding: '10px',
    background: 'white',
    cursor: 'pointer',
    borderBottomLeftRadius: '30px',
    boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 1px, rgba(0, 0, 0, 0.23) 0px 1px 1px',
    position: 'absolute',
    right: '-5px',
    top: '-5px',
    '&:hover': {
      boxShadow: ' rgba(0, 0, 0, 0.16) 0px 3px 6px inset, rgba(0, 0, 0, 0.23) 0px 3px 6px inset',
    },
  },
  dateInput: {
    width: '190px',
    padding: '10px',
    borderRadius: '5px',
    border: '1px solid rgba(0, 0, 0, 0.42)',
    outline: 'none',
    cursor: 'pointer',
  },
  tableHeaderSort: {
    marginInlineStart: '7px',
  },
  sortIcon: {
    color: 'black',
    cursor: 'pointer',
    '&:hover': {
      color: '#358c5e',
    },
  },
});
const CustomTable = ({ tableBodyData, getAllUsers, type, movePendingUser, moveUser, deleteUser, totalUser }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  /* Function to show image URL or fallback to default */
  const showImgURL = val => (val ? getImg(val) : images);
  console.log(tableBodyData,"tableBodyData")
  const totalPages_pre = totalUser / 10;
  const totalUserPages =
    totalUser % 10 === 0
      ? totalPages_pre
      : Math.trunc(totalPages_pre) + 1;

  const [clickedElement, setClickedElement] = useState(null);
  const [selectedUser, setSelectedUser] = useState('');
  const [uploadPic, setUploadPic] = useState(false);
  const [uploadUserId, setUploadUserId] = useState('');
  const [receivedFile, setReceivedFile] = useState(false);
  const [imageFile, setImageFile] = useState('');
  const [searchText, setSearchText] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [sortType, setSortType] = useState('createdAt');
  const [sortCreatedDate, setsortCreatedDate] = useState(true);
  const [sortName, setSortName] = useState(true);
  const [page, setPage] = useState(1);
  const [startCount, setStartCount] = useState(0);

  const open = Boolean(clickedElement);
  /* Define the default headers for the table */
  const defaultHeaders = [
    'image',
    'identityProof',
    'gender',
    'userName',
    'email',
    'WBO',
    'loginType',
    'status',
    'onboardingCompleted',
    'isVerified',
    'createdAt',
    'action',
  ];

  useEffect(() => {
    setStartCount((page - 1) * 10);
  }, [page]);

  useEffect(() => {
    getAllUsers(startCount, searchText, fromDate, toDate, sortType, getSortType(sortType));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    sortName,
    sortCreatedDate,
    sortType,
    fromDate,
    toDate,
    searchText,
    startCount
  ]);

  const getSortType = val => {
    if (val === 'createdAt') {
      if (sortCreatedDate) {
        return -1;
      } else {
        return 1;
      }
    } else {
      if (sortName) {
        return 1;
      } else {
        return -1;
      }
    }
  };

  const getFile = file => {
    setReceivedFile(true);
    setImageFile(file);
    setUploadPic(false);
  };

  const handleChange = event => {
    setSearchText(event.target.value.trim());
    setPage(1);
  };

  const getCropImgMyProfile = (files) => {
    setReceivedFile(false);

    // Create a FormData object
    const formObjData = new FormData();

    // Append the file to the FormData
    formObjData.append('userId', uploadUserId);
    formObjData.append('image', files);

    // Dispatch the action with the FormData as payload
    dispatch(uploadIdentityProofRequest({ data: formObjData, func: getAllUsers(startCount) }));

    // Reset state or perform any other necessary actions
    setImageFile('');
  };

  const handleModalCancel = () => {
    setReceivedFile(false);
  }

  /* Function to map login type data to corresponding labels */
  const getLoginTypeData = val => {
    switch (val) {
      case 1:
        return 'ADMIN';
      case 2:
        return 'USER';
      case 3:
        return 'PARTNER';
      default:
        break;
    }
  };

  /* Function to render verification status data */
  const getVerifyData = val =>
    val ? (
      <BsCheck size={30} className={classes.green} />
    ) : (
      <BsX size={30} className={classes.red} />
    );

  const handleAction = (event, user) => {
    console.log(event.currentTarget, "handleAction")
    setClickedElement(event.currentTarget);
    setSelectedUser(user._id);
  };

  const handleClose = () => {
    setClickedElement(null);
  };

  const handleMoveUser = (id, variety) => {
    console.log(id, variety, 'handleMoveUser');
    if (variety === 'verify') {
      moveUser(startCount, id, variety, true);
    } else if (variety === 'unverify') {
      moveUser(startCount, id, variety, true);
    } else if (variety === 'pending') {
      movePendingUser(startCount, id, variety, false);
    }
    handleClose();
  };
  const handleDeleteUser = id => {
    console.log(id, 'handleDeleteUser');
    deleteUser(id);
    handleClose();
  };

  const handleUpload = id => {
    setUploadPic(true);
    setUploadUserId(id)
    console.log(id, 'handleUpload');
    handleClose();
  };

  const pageFunc = () => {
    if (totalUserPages) {
      return totalUserPages;
    }
    return 0;
  };
  const handlePageChange = value => {
    setPage(value);
  };

  const getMenu = user => {
    return (
      <Menu anchorEl={clickedElement} open={open} onClose={handleClose}>
        {type === 'pending' ? (
          <>
            <MenuItem onClick={() => handleMoveUser(user._id, 'verify')}>
              Move to Verified User
            </MenuItem>
            <MenuItem onClick={() => handleMoveUser(user._id, 'unverify')}>
              Move to Unverified User
            </MenuItem>
            <MenuItem onClick={() => handleDeleteUser(user._id)}>
              Delete User
            </MenuItem>
          </>
        )
          :
          (<MenuItem onClick={() => handleMoveUser(user._id, 'pending')}>
            Move to Pending User
          </MenuItem>)
        }
        <MenuItem onClick={() => handleUpload(user._id)}>
          Upload Identity Proof
        </MenuItem>
      </Menu>
    );
  };

  /* Function to map data values to corresponding header names */
  const getHeaderName = val => {
    switch (val) {
      case 'image':
        return 'Profile Image';
      case 'identityProof':
        return 'Identity Proof Image';
      case 'gender':
        return 'Gender';
      case 'userName':
        return (
          <>
            <span>Name</span>
            <span className={classes.tableHeaderSort}>
              {sortName ? (
                <AiOutlineSortAscending
                  onClick={() => {
                    setSortName(!sortName);
                    setSortType('userName');
                  }}
                  size={22}
                  className={classes.sortIcon}

                />
              ) : (
                <AiOutlineSortDescending
                  className={classes.sortIcon}
                  size={22}
                  onClick={() => {
                    setSortName(!sortName);
                    setSortType('userName');
                  }}
                />
              )}
            </span>
          </>
        );
      case 'email':
        return 'Email';
      case 'WBO':
        return 'WBO';
      case 'loginType':
        return 'Login Type';
      case 'status':
        return 'Status';
      case 'onboardingCompleted':
        return 'Onboarding Completed';
      case 'isVerified':
        return 'Is Verified';
      case 'createdAt':
        return (
          <>
            <span>Created At</span>
            <span className={classes.tableHeaderSort}>
              <GoSortDesc
                className={classes.sortIcon}
                size={22}
                onClick={() => {
                  setSortType('createdAt');
                  setsortCreatedDate(!sortCreatedDate);
                }}
                style={{
                  transform: `${sortCreatedDate
                    ? 'rotate(0deg)'
                    : 'rotate(180deg)'
                    }`,
                }}

              />
            </span>
          </>
        );
      case 'action':
        return 'Action';
      default:
        /* Handle unknown values with a default case */
        break;
    }
  };

  /* Function to render table data based on data category */
  const getTableData = (obj, val) => {
    const imgData = ['image', 'identityProof'];
    const simpleData = ['gender', 'userName', 'email', 'WBO'];
    const loginData = ['loginType'];
    const statusData = ['status'];
    const verifiedData = ['onboardingCompleted', 'isVerified'];
    const dateData = ['createdAt'];
    const actionData = ['action'];

    if (imgData.includes(val)) {
      /* Render image data */
      return (
        <TableCell align="center">
          <img
            src={showImgURL(obj[val])}
            alt="profile pic"
            className={classes.imgWidth}
          />
        </TableCell>
      );
    } else if (simpleData.includes(val)) {
      /* Render simple text data */
      return <TableCell align="center">{obj[val]}</TableCell>;
    } else if (loginData.includes(val)) {
      /* Render login type data */
      return <TableCell align="center">{getLoginTypeData(obj[val])}</TableCell>;
    } else if (statusData.includes(val)) {
      /* Render status data with styles */
      return (
        <TableCell align="center">
          <div
            className={`${classes.status} ${obj[val] ? classes.activate : classes.deactivate
              }`}
          ></div>
        </TableCell>
      );
    } else if (verifiedData.includes(val)) {
      /* Render verification status data */
      return <TableCell align="center">{getVerifyData(obj[val])}</TableCell>;
    } else if (dateData.includes(val)) {
      /* Render date data in a specific format */
      return (
        <TableCell align="center">
          {moment(obj[val]).format('DD-MM-YYYY')}
        </TableCell>
      );
    } else if (actionData.includes(val)) {
      /* Display actions */
      return (
        <TableCell align="center">
          <Button onClick={e => handleAction(e, obj)}>
            <BiDotsVerticalRounded style={{ fontSize: '28px' }} />
          </Button>
          {selectedUser === obj?._id && getMenu(obj)}
        </TableCell>
      );
    } else {
      /* Return an empty fragment for unknown categories */
      return <></>;
    }
  };

  return (
    <>
      <div
        style={{
          width: '100%',
          padding: '0 22px',
          display: 'flex',
          justifyContent: 'space-around',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <GoSearch
            style={{
              margin: '16px 10px 0 0',
            }}
            color="#c9c9c9"
            size={18}
          />

          <TextField
            label="Search"
            id="standard-basic"
            onChange={handleChange}
            variant="standard"
          />
        </div>
        <div
          style={{
            display: 'flex',
            gap: '50px',
            justifyContent: 'flex-end',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <div
            style={{
              display: 'flex',
              gap: '20px',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <div>From</div>
            <input
              className={classes.dateInput}
              type="date"
              max={new Date().toISOString().split('T')[0]}
              onChange={e => setFromDate(e.target.value)}

            />
          </div>
          <div
            style={{
              display: 'flex',
              gap: '20px',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <div>To</div>
            <input
              className={classes.dateInput}
              type="date"
              max={new Date().toISOString().split('T')[0]}
              min={fromDate}
              onChange={e => setToDate(e.target.value)}
            />
          </div>
        </div>
      </div>
      <TableContainer className={classes.container} component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              {/* Render table headers based on default headers */}
              {defaultHeaders.map((header, index) => (
                <TableCell
                  key={index}
                  align="center"
                  className={classes.tabelHeaderColor}
                >
                  {getHeaderName(header)}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {
              tableBodyData?.map(obj => (
                <TableRow key={obj._id} align="center">
                  {defaultHeaders?.map(item => getTableData(obj, item))}
                </TableRow>
              ))
            }
          </TableBody>
        </Table>
      </TableContainer>
      <div className={classes.pagination}>
        <Pagination
          color="primary"
          count={pageFunc()}
          page={page}
          onChange={(_e, val) => handlePageChange(val)}
        />
      </div>
      {uploadPic && (
        <div className={classes.uploadImgmodal}>
          <div className={classes.uploadImgmodalChildren}>
            <div onClick={() => setUploadPic(false)} className={classes.uploadImgmodalCross} ><RxCross2 size={30} /></div>
            <DragAndDropInputDiv getFile={getFile} />
          </div>
        </div>
      )}
      {imageFile && receivedFile ? (
        <div className={classes.uploadImgmodal}>
          <div className={classes.uploadImgmodalChildren}>
            <ImageCrop
              src={imageFile}
              circularCrop={false}
              onImageLoaded={setImageFile}
              getImage={getCropImgMyProfile}
              activeBorder={true}
              cropCancel={handleModalCancel}
            />
          </div>
        </div>
      ) : (
        null
      )}
    </>
  );
};

export default CustomTable;
